module.exports = __webpack_public_path__ + "static/media/Take Tour.a15e226c.svg";